export const createWordDeclensions = (number, array) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return `${array[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]}`;
}; // функция для склонения слов
export const dayWordsArray = ['День', 'Дня', 'Дней'];
export const hoursWordsArray = ['Час', 'Часа', 'Часов'];
export const minutesWordsArray = ['Минута', 'Минуты', 'Минут'];
